import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import Dropdown from "../../../components/Dropdown";
import { Input } from "../../../components/Input";
import LeftSide from "../../../components/LeftSide";
import ModalAction from "../../../components/ModalAction";
import ModalSkeleton from "../../../components/ModalSkeleton";
import PhoneInput from "../../../components/PhoneInput";
import { LocationIcon } from "../../../constant";
import { refundAndCancelSchema } from "../../../schema";
import classes from "./AddOrEditLocationModal.module.css";
import useApi from "../../../useApi";
import {
  getAllCountries,
  getCityFromCountry,
} from "../../../lib/locations-lib";
import country_data from "../../../data/country-data";
const initialValues = {
  locationName: "",
  locationAddress: "",
  locationCity: "",
  locationCountry: "",
  countryCode: "",
  cellNumber: "",
};

const AddOrEditLocationModal = ({ show, setShow, data, onSubmit }) => {
  const [charCount, setCharCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const { addLocation, updateLocation } = useApi();
  const MAX_CHARS = 10000;

  useEffect(() => {
    if (data) {
      console.log("data", data);
      setFieldValue("locationName", data?.locationName);
      setFieldValue("locationAddress", data?.locationAddress);
      setFieldValue(
        "locationCity",
        getCityFromCountry(1)?.find(
          (item) => item?.label === data?.locationCity
        )?.id || ""
      );
      setFieldValue(
        "locationCountry",
        getAllCountries()?.find(
          (country) => country?.name === data?.locationCountry
        )?.id || ""
      );
      setFieldValue("cellNumber", `${data?.locationPhoneNo}`);
    }
  }, [data]);

  const formik = useFormik({
    initialValues,
    validationSchema: refundAndCancelSchema,
    onSubmit: (values, { resetForm }) => {
      console.log("values", values);
      const params = {
        ...(data?.locationId && { locationId: data?.locationId }),
        locationName: values?.locationName,
        locationAddress: values?.locationAddress,
        locationCity: getCityFromCountry(values?.locationCountry)?.find(
          (item) => item?.id === values?.locationCity
        )?.label,
        locationCountry: getAllCountries()?.find(
          (country) => country?.id === values?.locationCountry
        )?.name,
        cellNumber: values?.cellNumber?.slice(2),
        countryCode: `+${values?.cellNumber?.slice(0, 2)}`,
        delete: false,
        // countryCode: values?.cellNumber
      };

      console.log("PARAMS", params);
      if (typeof onSubmit === "function") {
        onSubmit(params);
      }
    },
  });
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
  } = formik;
  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
    // Update character count for reason field
    if (field === "address") {
      setCharCount(value?.length || 0);
    }
  };

  return (
    <>
      <ModalSkeleton
        width="700px"
        show={show}
        setShow={setShow}
        title={`${data ? "Edit" : "Add"} Location`}
      >
        <form onSubmit={handleSubmit}>
          <Row className={classes.controlGrid}>
            <Col md={6}>
              <Dropdown
                options={getAllCountries()}
                icon={<LeftSide icon={<LocationIcon />} />}
                customStyle={{ gap: "4px" }}
                inputStyle={{ paddingLeft: "0" }}
                labelStyle={{ fontSize: "16px" }}
                label={"Country"}
                placeholder="Select Country"
                value={values?.locationCountry}
                onChange={handleChangeWithTouch("locationCountry")}
                errorText={touched?.locationCountry && errors?.locationCountry}
              />
            </Col>
            <Col md={6}>
              <Dropdown
                options={getCityFromCountry(values?.locationCountry)}
                icon={<LeftSide icon={<LocationIcon />} />}
                customStyle={{ gap: "4px" }}
                inputStyle={{ paddingLeft: "0" }}
                labelStyle={{ fontSize: "16px" }}
                label={"City"}
                placeholder="Select City"
                value={values?.locationCity}
                onChange={handleChangeWithTouch("locationCity")}
                errorText={touched?.locationCity && errors?.locationCity}
              />
            </Col>

            <Col md={6}>
              <PhoneInput
                labelStyle={{ fontSize: "16px" }}
                label={"Phone Number"}
                placeholder="Enter Phone Number"
                value={values?.cellNumber}
                onChange={(e) => handleChangeWithTouch("cellNumber")(e)}
                errorText={touched?.cellNumber && errors?.cellNumber}
              />
            </Col>
            <Col md={6}>
              <Input
                leftIcon={<LocationIcon />}
                customStyle={{ gap: "15px" }}
                inputStyle={{ paddingLeft: "0px" }}
                type="text"
                labelStyle={{ fontSize: "16px" }}
                label={"Location Name"}
                placeholder="Enter Location Name"
                value={values?.locationName}
                onChange={(e) => {
                  handleChangeWithTouch("locationName")(e);
                }}
                errorText={touched?.locationName && errors?.locationName}
              />
            </Col>
            <Col md={12}>
              <Input
                isOptional={true}
                customStyle={{ gap: "15px" }}
                inputStyle={{ paddingLeft: "0" }}
                type="text"
                leftIcon={<LocationIcon />}
                labelStyle={{ fontSize: "16px" }}
                label={"Address"}
                placeholder="Enter Address"
                value={values?.locationAddress}
                onChange={(e) => {
                  // Validate character count
                  if (e?.length > MAX_CHARS) {
                    toast.warn(`Address cannot exceed ${MAX_CHARS} characters`);
                    return;
                  }
                  handleChangeWithTouch("locationAddress")(e);
                }}
                errorText={
                  (touched?.locationAddress && errors?.locationAddress) ||
                  (charCount > MAX_CHARS &&
                    `Address cannot exceed ${MAX_CHARS} characters`)
                }
              />
              <div className={classes.charCounter}>
                {charCount}/{MAX_CHARS} characters
              </div>
            </Col>
          </Row>

          <ModalAction type="submit" onCancel={() => setShow(false)} />
        </form>
      </ModalSkeleton>
    </>
  );
};

export default AddOrEditLocationModal;
